import React from "react";

import { faCheck, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bem } from "@react-md/utils";
import cn from "classnames";

import Button from "../../../Button";

interface InlineButtonsProps {
  className?: string;
  onCancel?: React.MouseEventHandler<HTMLElement>;
  onSave?: React.MouseEventHandler<HTMLElement>;
  size?: "middle" | "small";
}

const block = bem("mmc-inline-buttons");

const InlineButtons = ({ className, onCancel, onSave, size = "small" }: InlineButtonsProps) => {
  return (
    <div className={cn(block(), className)}>
      <Button
        className={cn(block("button"), "mmc-js-skip-save-on-blur")}
        icon={<FontAwesomeIcon icon={faTimes} />}
        onClick={onCancel}
        size={size}
        type="default"
      />
      <Button
        className={cn(block("button"), "mmc-js-save-on-blur")}
        icon={<FontAwesomeIcon icon={faCheck} />}
        onClick={onSave}
        size={size}
        type="primary"
      />
    </div>
  );
};

export default InlineButtons;
